// Mock data for CLND Menkul website

export const services = [
  {
    id: 1,
    title: "VİOP İŞLEMLERİ",
    description: "Hemen İncele",
    url: "/hizmetler/viop-islemleri",
    image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/qih3ju09_viop.png"
  },
  {
    id: 2,
    title: "PAY ALIM-SATIM",
    description: "Hemen İncele",
    url: "/hizmetler/pay-alim-satim",
    image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/941o2s4c_payalim.png"
  },
  {
    id: 3,
    title: "YATIRIM FONLARI",
    description: "Hemen İncele",
    url: "/hizmetler/yatirim-fonlari",
    image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/f4p0nkgh_ytf.png"
  },
  {
    id: 4,
    title: "YATIRIM DANIŞMANLIĞI",
    description: "Hemen İncele",
    url: "/hizmetler/yatirim-danismanligi",
    image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/gokfabac_ytd.png"
  }
];

export const announcements = [
  {
    id: 1,
    date: "06 Nisan 2026",
    title: "Uygulama Erişimi Hakkında Bilgilendirme",
    description: "Uygulama Erişimi Hakkında Bilgilendirme",
    url: "/duyurular/uygulama-erisimi"
  },
  {
    id: 2,
    date: "03 Nisan 2026",
    title: "Altyapı Bakım Çalışması Hakkında Önemli Bilgilendirme",
    description: "Altyapı Bakım Çalışması Hakkında Önemli Bilgilendirme",
    url: "/duyurular/altyapi-bakim"
  },
  {
    id: 3,
    date: "01 Nisan 2026",
    title: "Piyasa Kapanış Saatleri Güncelleme",
    description: "Piyasa Kapanış Saatleri Güncelleme",
    url: "/duyurular/piyasa-kapanisi"
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Güvenli Yatırım Deneyimi",
    description: "Yatırımlarınız, Merkezi Kayıt Kuruluşu nezdinde kendi adınıza ve hesabınıza saklanır. CLND Menkul Değerler olarak, regülasyonlara tam uyum ve şeffaflık ilkesiyle yatırımlarınızı koruma altına alıyoruz.",
    image: "https://colendimenkul.com/img/WhyUs/488b72d0-25b4-4d88-b5c4-d3f52831259f.png"
  },
  {
    id: 2,
    title: "Güçlü Teknoloji Altyapısı",
    description: "Emir yönlendirme sistemi, çoklu borsa entegrasyonu ve gerçek zamanlı veri akışıyla piyasa hızını yakalayın. Güçlü sunucu altyapımız sayesinde emirlerinizi milisaniyeler içinde borsaya iletiyor, kesintisiz işlem sunuyoruz.",
    image: "https://colendimenkul.com/img/WhyUs/5920030e-ce3f-4083-bc67-810b55af8a4e.png"
  },
  {
    id: 3,
    title: "Rekabetçi Komisyon Oranları",
    description: "Yatırım getirinizi işlem maliyetlerine harcamayın. Her hacme uygun avantajlı komisyon oranlarımız ve şeffaf fiyatlama politikamızla yanınızdayız. CLND Menkul Değerler ile kazancınızı maksimize etmeye odaklanın.",
    image: "https://colendimenkul.com/img/WhyUs/70f60f94-5c0b-4878-bf34-96f7ee0c8d44.png"
  }
];

export const platforms = [
  {
    id: 1,
    name: "Web Platform",
    image: "https://colendimenkul.com/img/Platforms/9b33c1e9-7fa8-4cbd-9526-71f8d6e503a1.png"
  },
  {
    id: 2,
    name: "Mobile Platform",
    image: "https://colendimenkul.com/img/Platforms/68a87798-5d5d-4bcc-9a4f-2cd439e31032.png"
  },
  {
    id: 3,
    name: "Desktop Platform",
    image: "https://colendimenkul.com/img/Platforms/4fe87eae-55fe-4476-bb84-f7ed933e700e.jpg"
  }
];

export const marketData = [
  {
    id: 1,
    name: "BIST 100",
    value: "10.245,67",
    change: "+2.45%",
    isPositive: true
  },
  {
    id: 2,
    name: "USD/TRY",
    value: "32.45",
    change: "+0.15%",
    isPositive: true
  },
  {
    id: 3,
    name: "EUR/TRY",
    value: "35.12",
    change: "-0.08%",
    isPositive: false
  },
  {
    id: 4,
    name: "GOLD",
    value: "2.845,32",
    change: "+1.23%",
    isPositive: true
  }
];

export const analysisArticles = [
  {
    id: 1,
    title: "Haftalık Piyasa Analizi",
    date: "10 Nisan 2026",
    author: "Uzman Ekip",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80",
    description: "Bu hafta piyasalarda yaşanan gelişmeler ve önümüzdeki hafta için beklentiler."
  },
  {
    id: 2,
    title: "Teknoloji Sektörü Değerlendirmesi",
    date: "08 Nisan 2026",
    author: "Analist Ekibi",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    description: "Teknoloji şirketlerinin son dönem performansları ve değerlendirmeler."
  },
  {
    id: 3,
    title: "Küresel Piyasalara Bakış",
    date: "05 Nisan 2026",
    author: "Strateji Ekibi",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=800&q=80",
    description: "Dünya borsalarındaki son gelişmeler ve Türkiye piyasalarına etkisi."
  }
];